import { Box, Typography } from "@mui/material"
import { Status } from "../../../../../../../utils/enums"
import { PointType } from "../../../utils/enums/pointType"
import { useTranslation } from "react-i18next"
import { getStatus } from "../../../../../../../hooks/status"
import { useContextState } from "../../../../../../../hooks/theme"
import { useStyles } from "./styles"


export const MapPointUser = ({ extraData, status, type, useData, count }: { status: Status, extraData: string, useData: string, type: PointType, count: number }) => {

    const { t } = useTranslation()
    const { colors } = useContextState()
    const styles = useStyles()
    const colorPoint = getStatus(status, colors, t)
    const isNoFinisf = status === Status.NOT_FINISHED ? true : false;
    const colorNoFinish = colors.color13
    const getTitle = (type: PointType) => {
        let title = '';
        switch (type) {
            case PointType.END:
                title = t('loogbook.pointType.end')
                break
            case PointType.START:
                title = t('loogbook.pointType.start')
                break
            case PointType.UNITY:
                title = t('loogbook.pointType.unity')
                break
            case PointType.UNITYT_START_END:
                title = t('loogbook.pointType.unity_start_end')
                break
            case PointType.UNITY_END:
                title = t('loogbook.pointType.unity_end')
                break
            case PointType.UNITY_START:
                title = t('loogbook.pointType.unity_start')
                break
            case PointType.START_END:
                title = t('loogbook.pointType.start_end')
                break
            default:
                title = t('loogbook.pointType.unity_start_end')
        }
        return title;
    }


    return (
        <Box sx={styles.container}>
            <Box sx={styles.mark}>
                <Typography sx={styles.header(isNoFinisf ? colorNoFinish : colorPoint.color)}>{getTitle(type)}</Typography>
                <Box sx={styles.containerMark}>
                    {count <= 1 && <Typography sx={styles.user}>{useData}</Typography>}
                    <svg width="50" height="62" viewBox="0 0 50 70" xmlns="http://www.w3.org/2000/svg">
                        {/* <!-- Pin base --> */}
                        <path d="M25 0
                            C11.2 0 0 11.2 0 25
                            C0 39.6 25 70 25 70
                            C25 70 50 39.6 50 25
                            C50 11.2 38.8 0 25 0Z"
                            fill={isNoFinisf ? colorNoFinish : colorPoint.color}
                        />

                        {/* <!-- Círculo blanco central --> */}
                        <circle cx="25" cy="25" r="17" fill="white" />

                        {/* <!-- Texto en el centro --> */}
                        <text x="25" y="30" font-size="12" text-anchor="middle" fill="black" font-weight="bold">{count <= 1 ? extraData : 'X' /* count */}</text>
                    </svg>
                </Box>
            </Box>
        </Box>
    )
}